export const Inventory={
    warehouseIOSources:{
        InventoryReceipt:{
            WithoutSource:"WithoutSource",
        },
         InventoryRemittance:{
            WithoutSource:"WithoutSource",
            ItemRequests:"ItemRequests",
            TransferReceipt:"TransferReceipt_WarehouseIOs",
        },
        ReturnReceipt:{
            WithoutSource:"WithoutSource",
            InventoryRemittance:"InventoryRemittance_WarehouseIOs"

        },
         ReturnRemittance:{
            WithoutSource:"WithoutSource",
            InventoryReceipt:"InventoryReceipt_WarehouseIOs"
            
        },
        TransferReceipt:{
            TransferRemittance:"TransferRemittance_WarehouseIOs"
        },
        TransferRemittance:{
             WithoutSource:"WithoutSource",
            // ItemRequests:"ItemRequests",

        },
         InventoryBalancing:{
             WithoutSource:"WithoutSource",
        },
        DirectDelivery:{
             WithoutSource:"WithoutSource",
            // ItemRequests:"ItemRequests",

        }
    }
}